export default __webpack_public_path__ + "static/media/promo-issue-no-1_01.9233de1c.jpg";